import { render } from "./index.vue?vue&type=template&id=574f12e8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=574f12e8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-574f12e8"

export default script